module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921042651_T.fe3a9df7.jpg";